import React from 'react';

const SectionTitle = ({ 
  title, 
  subtitle, 
  centered = true, 
  light = false,
  badge = null,
  className = '' 
}) => {
  return (
    <div className={`mb-12 md:mb-16 ${centered ? 'text-center' : ''} ${className}`}>
      {badge && (
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#F7C948]/10 border border-[#F7C948]/20 text-[#F7C948] text-sm font-medium mb-4">
          {badge}
        </div>
      )}
      <h2 className={`font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-4 ${
        light ? 'text-white' : 'text-white'
      }`}>
        {title}
      </h2>
      {subtitle && (
        <p className={`text-lg md:text-xl max-w-2xl ${
          centered ? 'mx-auto' : ''
        } ${light ? 'text-gray-300' : 'text-gray-400'}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionTitle;
